import qs from 'qs'
import request from '@/utils/request'
request.defaults.baseURL = process.env.VUE_APP_GLY_URL;

export function login(data) {
    return request({
      url: '/check/auth?username='+data.username+'&password='+data.password,
      method: 'get',
      data: qs.stringify({})
    })
}
// export function menu() {
//     return request({
//       url: '/sys/menu/nav',
//       method: 'get',
//       data: qs.stringify({})
//     })
// }

